export default __webpack_public_path__ + "static/media/pin_amarelo.28609281.png";